import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { buttonVariants } from '@/components/app/button';
import { LogoSVG } from '@/components/app/logo';
import { Sheet, SheetContent, SheetHeader, SheetTrigger } from '@/components/ui/sheet';
import { useIsRTL } from '@/hooks/i18n.hooks';
import { cn } from '@/lib/utils';

function Header() {
	const isRTL = useIsRTL();
	return (
		<header className="w-full">
			<div
				className={cn(
					'mx-auto flex w-full max-w-screen-sm items-center justify-between p-4',
					isRTL ? 'flex-row' : 'flex-row-reverse',
				)}
			>
				<Link to="/">
					<LogoSVG className="h-5 fill-ash-900" />
				</Link>
				<MobileMenu />
			</div>
		</header>
	);
}

function MobileMenu() {
	const { t } = useTranslation();
	// we need this here because the sheet dialog will be rendered outside of the root element (we set dir based on the locale on the root element)
	const isRTL = useIsRTL();

	return (
		<Sheet>
			<SheetTrigger className="flex items-center justify-center">
				<span
					className="icon-[tabler--menu-2] cursor-pointer bg-ash-800 text-3xl"
					data-icon="tabler:menu-2"
					data-inline="false"
				/>
			</SheetTrigger>
			<SheetContent side="left" className="w-[280px]" dir={isRTL ? 'rtl' : 'ltr'}>
				<SheetHeader className="h-12 bg-ash-100" />
				<ul className="flex flex-col overflow-y-scroll">
					<MenuItem to="/programs">{t('layout.nav.programs')}</MenuItem>
					<MenuItem to="/adventures">{t('layout.nav.adventures')}</MenuItem>
					<MenuItem to="/philosophy">{t('layout.nav.philosophy')}</MenuItem>
					<MenuItem to="/trainers">{t('layout.nav.trainers')}</MenuItem>
					<MenuItem to="/about-us">{t('layout.nav.about_us')}</MenuItem>
					<MenuItem to="/contact">{t('layout.nav.contact')}</MenuItem>
					<MenuItem to="/wod">{t('layout.nav.wod')}</MenuItem>
					{/* <MenuItem
            to="/wod"
            className="bg-foreground hover:text-ash-800 group flex items-center justify-between text-white transition-colors duration-150 hover:bg-amber-400"
          >
            <span className="text-background">{t('layout.nav.wod')}</span>
            <span
              className="icon-[tabler--skull] text-ash-800 group-hover:bg-ash-800 ms-2 bg-amber-300 text-2xl transition-colors duration-150 group-hover:text-amber-400"
              data-icon="tabler:skull"
              data-inline="false"
            />
          </MenuItem> */}
				</ul>
				<div className="mt-10 flex items-center justify-center">
					<Link to="/login" className={cn(buttonVariants({ size: 'lg' }))}>
						{t('layout.login')}
					</Link>
				</div>
			</SheetContent>
		</Sheet>
	);
}

function MenuItem({
	to,
	className = '',
	children,
}: {
	to: string;
	className?: string;
	children: React.ReactNode;
}) {
	return (
		<li className={cn('border-ash-200 border-b hover:bg-ash-100', className)}>
			<Link to={to} className="group flex items-center px-5 py-3">
				{children}
			</Link>
		</li>
	);
}

export { Header };
